import React from "react";
import { Card, Col, Divider, Row } from "antd";
import ListPending from "../Bookings/BeApproved/Pending";
import { useQuery } from "react-query";
import { getKpis } from "../../services/dashboard.service";
import Kpi from './Kpi';
import { isMobile } from "react-device-detect";

export default function Dashboard() {
    const { isLoading, data: kpis } = useQuery(
        ['loadKpis'], () => getKpis(), { refetchOnWindowFocus: false }
    );

    const kpisDivider = (key: string) => (<Divider key={key} type="vertical"
        style={{ height: "4em", marginLeft: "2em", marginRight: "2em" }} />)

    const kpisCard = {
        today: 'Serviços Hoje',
        tomorrow: 'Serviços Amanhã',
        unassigned: 'Por Atribuir'
    };

    const appKpisCard = {
        closed: 'Fechados',
        approved: 'Aceites',
        pending: 'Pendentes'
    };

    return (
        <div
            style={{
                margin: 24,
                display: "flex",
                flexDirection: "column",
                gap: 16,
            }}
        >
            <Row gutter={20}>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <Card title="Serviços">
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            {Object.entries(kpisCard).map(([attr, title], index: number) => (<>
                                <Kpi key={'s' + index} title={title} value={kpis?.data[attr]} isLoading={isLoading}
                                    tagText={attr === 'unassigned' && kpis?.data[attr]
                                        ? 'Em aberto' : undefined}></Kpi>
                                {index < Object.keys(kpisCard).length - 1 && kpisDivider('s_divider' + index)}
                            </>))}
                        </div>
                    </Card>
                </Col>

                <Col xs={24} sm={24} md={24} lg={12} xl={12} style={isMobile ? { marginTop: 16 } : {}}>
                    <Card title="Estado dos Serviços">
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            {Object.entries(appKpisCard).map(([attr, title], index: number) => (<>
                                <Kpi key={'es' + index} title={title} value={kpis?.data[attr]} isLoading={isLoading}></Kpi>
                                {index < Object.keys(kpisCard).length - 1 && kpisDivider('es_divider' + index)}
                            </>))}
                        </div>
                    </Card>
                </Col>
            </Row>

            <Row gutter={20}>
                <Col span={24}>
                    <Card title="Reservas por aprovar">
                        <ListPending hideFilter={true} />
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
